// extracted by mini-css-extract-plugin
export var gif = "_jw-0";